/* eslint-disable prettier/prettier */
// @flow

import React from 'react'
import { createComponent } from 'react-fela'
import { getIn } from 'timm'
import PropTypes from 'prop-types'
import Icon from 'design-framework/common/ui/Icon'
import RightArrow from 'design-framework/common/icons/arrow-right.svg'
import filterTick from 'design-framework/common/icons/filter-tick.svg'
import PriceFilter from 'design-framework/components/PriceFilter/index'
import Accordion from 'design-framework/atoms/Accordion'
import Pills from 'design-framework/components/Pills/Pills'
import defaultTheme from 'design-framework/utils/base-ui-theme'
import DateFilter from './DateFilter'

import {
	__header,
	__listContainer,
	__list,
	__item,
	__showMore,
	__subCategory,
	__subFilterLabel,
	__iconWrapper,
	__accordionHeader,
} from './__style'

const Header = createComponent(__header)
const ListContainer = createComponent(__listContainer)
const List = createComponent(__list, 'li')
const Item = createComponent(__item)
const ShowMore = createComponent(__showMore, 'li')
const SubCategory = createComponent(__subCategory)
const SubCategoryLabel = createComponent(__subFilterLabel, 'span')
const IconWrapper = createComponent(__iconWrapper)
const AccordionHeader = createComponent(__accordionHeader)

const FilterList = ({
	filterName,
	filterCode,
	filterList = [],
	showMore,
	handleShowHideState,
	showAllFilters,
	handleFilterClick,
	theme = defaultTheme,
}) => {
	const content = fltrCode => {
		switch (fltrCode) {
			case 'price':
				return (
					<List key={filterName} height="auto">
						<PriceFilter
							config={filterList}
							onChange={(value, code) =>
								handleFilterClick(
									{ name: value },
									code,
									null,
									false
								)
							}
							filterCode={fltrCode}
						/>
					</List>
				)
			case 'dates':
				return (
					<DateFilter
						config={filterList}
						onChange={(value, isActive, isMultiple) =>
							handleFilterClick(
								{ name: value },
								fltrCode,
								isActive,
								isMultiple
							)
						}
						filterCode={fltrCode}
						theme={theme}
					/>
				)
			case 'artists':
				return filterList.map(item => {
					const list = item.codes.reduce((agg, artist) => {
						const aggregator = agg
						aggregator[artist.criteria] = artist.isActive

						return aggregator
					}, {})

					return (
						<Accordion
							key={item.name}
							renderHeader={
								<AccordionHeader>{item.name}</AccordionHeader>
							}
							renderDropDown={
								<Pills
									style={{ marginBottom: theme.spaces[4] }}
									list={list}
									onToggle={({ label, isActive }) =>
										handleFilterClick(
											{
												name: {
													name: `${
														item.name
													}-${label}`,
													label,
													innerTitle: item.name,
												},
											},
											fltrCode,
											isActive
										)
									}
								/>
							}
							iconStyles={{
								width: '10px',
								marginTop: theme.spaces[14],
							}}
							styles={{
								padding: `0px ${theme.spaces[16]}`,
							}}
						/>
					)
				})
			default:
				return filterList.map(item => {
					const activeSubFilters = (
						getIn(item, ['activeSubCollections']) || []
					)
						.map(cfg => cfg.name)
						.join(', ')

					return (
						<List
							key={item.name}
							passThrough={['onClick']}
							onClick={() =>
								handleFilterClick &&
								handleFilterClick(item, fltrCode, filterName)
							}
						>
							<Item
								isActive={
									!item.hasSubCollection && item.isActive
								}
							>
								{item.name}
							</Item>
							<SubCategory>
								<SubCategoryLabel>
									{item.hasSubCollection &&
										item.isActive &&
										(activeSubFilters || 'All')}
								</SubCategoryLabel>

								{(item.hasSubCollection || item.isActive) && (
									<IconWrapper
										width={
											item.hasSubCollection ? '8' : '13'
										}
										height={
											item.hasSubCollection ? '13' : '13'
										}
									>
										<Icon
											glyph={
												item.hasSubCollection
													? RightArrow
													: filterTick
											}
										/>
									</IconWrapper>
								)}
							</SubCategory>
						</List>
					)
				})
		}
	}

	return (
		<div>
			{filterName && <Header>{filterName}</Header>}
			<ListContainer>
				{content(filterCode)}
				{showMore && (
					<ShowMore
						passThrough={['onClick']}
						onClick={handleShowHideState}
					>
						{showAllFilters ? 'Show all' : 'Show less'}
					</ShowMore>
				)}
			</ListContainer>
		</div>
	)
}

FilterList.propTypes = {
	filterName: PropTypes.string,
	filterCode: PropTypes.string,
	filterList: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			hasSubCollection: PropTypes.bool,
			isActive: PropTypes.bool,
		})
	),
	showMore: PropTypes.bool,
	handleShowHideState: PropTypes.func,
	showAllFilters: PropTypes.bool,
	handleFilterClick: PropTypes.func,
}

export default FilterList
